import { render, staticRenderFns } from "./Create-Demerit-Points.vue?vue&type=template&id=65d32340"
import script from "./Create-Demerit-Points.vue?vue&type=script&lang=js"
export * from "./Create-Demerit-Points.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports